import React from 'react';
import { statsData } from '../data/mock';

const StatsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-slate-900">KIP ENERGY en Chiffres</h2>
          <p className="mt-3 text-slate-600">Des résultats qui parlent d'eux-mêmes</p>
        </div>
        
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {statsData.map((stat, index) => (
            <div
              key={index}
              className="group relative bg-slate-50 rounded-2xl p-6 hover:bg-orange-50 transition-all duration-300 border border-transparent hover:border-orange-200"
            >
              <div className="text-center">
                <div className="text-4xl sm:text-5xl font-bold text-orange-500 group-hover:scale-110 transition-transform duration-300">
                  {stat.value}
                </div>
                <div className="mt-2 text-lg font-semibold text-slate-800">
                  {stat.label}
                </div>
                <div className="mt-1 text-sm text-slate-500">
                  {stat.description}
                </div>
              </div>
              
              {/* Decorative corner */}
              <div className="absolute top-3 right-3 w-2 h-2 bg-orange-300 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
